import { render, staticRenderFns } from "./pi-station-item.vue?vue&type=template&id=6b0027d4&scoped=true&"
import script from "./pi-station-item.vue?vue&type=script&lang=js&"
export * from "./pi-station-item.vue?vue&type=script&lang=js&"
import style0 from "./pi-station-item.vue?vue&type=style&index=0&id=6b0027d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0027d4",
  null
  
)

export default component.exports